<!-- The full-size picture or video for one item. Seed videos have a poster but no bytes. -->
<template>
  <div class="md-full" :class="{ contain }">
    <template v-if="item">
      <video v-if="item.kind === 'video' && url" :key="url" :src="url" controls playsinline preload="metadata" controlslist="nodownload" />
      <div v-else-if="item.kind === 'video'" class="md-full-poster">
        <img v-if="poster" :src="poster" alt="" />
        <p>Sample video: the seed has no file. Upload a video to play one.</p>
      </div>
      <img v-else-if="url" :src="url" :alt="item.note || 'Patient media'" draggable="false" />
      <div v-else class="md-full-missing">This file is not in this browser any more (local data was cleared).</div>
    </template>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { getMediaUrl } from '@/api/mediaApi';

const props = defineProps({
  item: { type: Object, default: null },
  contain: { type: Boolean, default: true },
});
const url = ref(null);
const poster = ref(null);
watch(() => props.item && props.item.public_id, async () => {
  url.value = null;
  poster.value = null;
  if (!props.item) return;
  url.value = await getMediaUrl(props.item, 'full');
  if (props.item.kind === 'video' && !url.value) poster.value = await getMediaUrl(props.item, 'thumb');
}, { immediate: true });
</script>

<style scoped>
.md-full { width:100%; height:100%; display:flex; align-items:center; justify-content:center; background:#11181b; }
.md-full img, .md-full video { max-width:100%; max-height:100%; display:block; }
.md-full.contain img, .md-full.contain video { object-fit:contain; width:100%; height:100%; }
.md-full-poster { position:relative; width:100%; height:100%; }
.md-full-poster img { width:100%; height:100%; object-fit:contain; opacity:.85; }
.md-full-poster p, .md-full-missing { position:absolute; left:0; right:0; bottom:12px; margin:0; text-align:center; color:#fff; font-size:14px; }
.md-full-missing { position:static; padding:24px; }
</style>
